import React, { FC, MouseEvent } from "react"
import { graphql } from "gatsby"

import { InlineCtaFragmentFragment } from "@graphqlTypes"

import { smoothScrollToElement } from "@utils"

import TextLink, { TEXT_LINK_SIZES } from "@components/TextLink/TextLink"

import LpSection from "../LpSection/LpSection"

import "./InlineCTA.scss"

const InlineCTA: FC<InlineCtaFragmentFragment> = ({
  background,
  contentful_id,
  ctaText,
  ctaUrl,
  descriptionText,
  hideOnMobile,
  includeBackground,
  marginBottom,
  useDarkMode,
}) => {
  const inPageAnchor = !!ctaUrl && ctaUrl.includes("#")
  const scrollToAnchor = inPageAnchor
    ? (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      smoothScrollToElement(ctaUrl.replace("#", ""))
    }
    : undefined

  return (
    <LpSection
      className={`InlineCTA ${hideOnMobile ? "hide-on-mobile" : ""}`}
      uniqueId={contentful_id}
      background={background}
      includeBackground={includeBackground}
      marginBottom={marginBottom}
      useDarkMode={useDarkMode}
    >
      <div className="container">
        <div className="flex text-wrapper">
          <p className="type--text-XL font-family--sans font-weight--light color--text-dark">
            {descriptionText}
          </p>
          {ctaUrl && ctaText && (
            <TextLink
              href={ctaUrl}
              onClick={scrollToAnchor}
              rotateIcon={inPageAnchor}
              size={TEXT_LINK_SIZES.L}
            >
              {ctaText}
            </TextLink>
          )}
        </div>
      </div>
    </LpSection>
  )
}

// TODO add GraphQL fragment
export const InlineCTAFragment = graphql`
  fragment InlineCtaFragment on ContentfulLpInlineCta {
    contentful_id
    # alias to prevent conflict with "text" field in other fragments
    descriptionText: text
    ctaText
    ctaUrl
    hideOnMobile
    background
    includeBackground
    marginBottom
    useDarkMode
  }
`

export default InlineCTA
